export default __webpack_public_path__ + "static/media/promos2.b3720470.webp";